import DiscardForm from 'components/RecurringOrderSuggestionsDiscardReasonsModal/Sections/DiscardForm/styled';

export default DiscardForm;
